export interface AlainUtilArrayConfig {
  /** æ·±åº¦é¡¹åï¼é»è®¤ï¼`'deep'` */
  deepMapName?: string;
  /** æå¹³åæ°ç»çç¶æ°æ®é¡¹åï¼é»è®¤ï¼`'parent'` */
  parentMapName?: string;
  /** ç¼å·é¡¹åï¼é»è®¤ï¼`'id'` */
  idMapName?: string;
  /** ç¶ç¼å·é¡¹åï¼é»è®¤ï¼`'parent_id'` */
  parentIdMapName?: string;
  /** æºæ°æ®å­é¡¹åï¼é»è®¤ï¼`'children'` */
  childrenMapName?: string;
  /** æ é¢é¡¹åï¼é»è®¤ï¼`'title'` */
  titleMapName?: string;
  /** èç¹ Checkbox æ¯å¦éä¸­é¡¹åï¼é»è®¤ï¼`'checked'` */
  checkedMapname?: string;
  /** èç¹æ¬èº«æ¯å¦éä¸­é¡¹åï¼é»è®¤ï¼`'selected'` */
  selectedMapname?: string;
  /** èç¹æ¯å¦å±å¼(å¶å­èç¹æ æ)é¡¹åï¼é»è®¤ï¼`'expanded'` */
  expandedMapname?: string;
  /** è®¾ç½®æ¯å¦ç¦ç¨èç¹(ä¸å¯è¿è¡ä»»ä½æä½)é¡¹åï¼é»è®¤ï¼`'disabled'` */
  disabledMapname?: string;
}
